import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {EventEmitter, Injectable} from '@angular/core';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {take} from 'rxjs/operators';
import {FileManagementService} from '@core/services/file-management.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class CbcFormsHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  cbcFormCountries: any;

  constructor(private fuseSplashScreenService: FuseSplashScreenService,
              private fileManagementService: FileManagementService,
              private commandService: CommandService,
              private particleCacheService: ParticleCacheService,
              private platformQueryService: PlatformQueryService,
              private dialogService: DialogService,
              private router: Router,
              private snackBarService: SnackBarService
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    switch (command.name) {
      case 'SelectCountryCommand':
        this.getPublishedCountry(command);
        return;
      default:
        break;
    }
    this.executeCommandToApi(command);
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand']);
            this.fuseSplashScreenService.hide();
            return;
          } else if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else if (commandResponse.fieldValues['DownloadResponse']) {
            this.fileManagementService.downloadClientFileWithId(commandResponse.fieldValues['DownloadResponse'].fileId)
              .subscribe(payload => {
              this.fuseSplashScreenService.hide();
              this.fileManagementService.openSaveFileWindow(payload, `${commandResponse.fieldValues['DownloadResponse'].fileName}`);
            });
            return;
          } else if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessageDuration'] ??
              commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            this.fuseSplashScreenService.hide();
            return;
          } else if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['ErrorMessage']);
            this.fuseSplashScreenService.hide();
            return;
          }
          this.fuseSplashScreenService.hide();
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed To Execute command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
    switch ($event.action.id) {
      case 'Download':
        this.downloadFile($event.item.cells.Link.value, $event);
        break;
    }
  }

  downloadFile(relativePath: string, event: any) {
    // this.store.dispatch(new fileStoreActions.DownloadFileByRelativePathAction(relativePath, `${event.item.cells.FormName.value}.pdf`));
    this.fuseSplashScreenService.show();
    this.fileManagementService.downloadFileByRelativePath(relativePath).pipe(take(1))
      .subscribe(data => {
        const extension = event.item.cells.Link.value.split('.')[event.item.cells.Link.value.split('.').length  - 1];
        this.fileManagementService.openSaveFileWindow(data, `${event.item.cells.FormName.value}.${extension}`);
        this.fuseSplashScreenService.hide();
      });
  }

  getPublishedCountry(command: PlatformCommand) {
    const platformQuery = new PlatformQuery();
    platformQuery.name = 'GetCbCFormPublishedCountriesQuery';
    platformQuery.api = Api.Spreadsheet;
    this.platformQueryService.executeQuery(platformQuery).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreenService.hide();
      this.cbcFormCountries = response.fieldValues['Countries'];
      this.onCountrySelect(command);
    });
  }

  onCountrySelect(command: PlatformCommand) {
    console.log('=>  Country selected and making trigger selector true');
    const dialogModel = DialogModel.create(
      'Select Country',
      'ChaptersCountrySelectorDialogComponent',
      {
        countries: this.cbcFormCountries,
        selectedCountry: this.cbcFormCountries.find(country => country.code === command.fieldValues['CountryFlag'])
      },
      '630px',
      '630px'
    );
    dialogModel.okCaption = 'Done';
    dialogModel.cancelCaption = 'Cancel';
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.data.input.selectedCountry) {
        // shall fire command again
        const executionCommand = new PlatformCommand('CBCFormsToolLinkCommand', Api.Spreadsheet);
        executionCommand.projectId = '[PROJECT_ID]';
        executionCommand.fieldValues['CountryCode'] = res.data.input.selectedCountry.code;
        this.executeCbCFormsUpdateCommand(executionCommand);
      }
    });
  }

  executeCbCFormsUpdateCommand(command) {
    command = JSON.parse(JSON.stringify(command));
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe((response: any) => {
        if (response.fieldValues['PlatformLinkModel']) {
          this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
          const sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
          const params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType);
          params['ShowArchivedSandbox'] = command.isChecked;
          this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, sourceType, params);
          this.refreshPlatformLink(response);
        } else {
          console.log('Platform link model not found');
          this.fuseSplashScreenService.hide();
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Operation failed!!!', error);
      });
  }

  private refreshPlatformLink(response: PlatformCommandResponse) {
    this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
    this.magicLinkModelValueChangedHandler({
      id: 'PlatformToolContainerComponent', value: response.fieldValues['PlatformLinkModel'],
      magicLinkModel: this.magicLinkModel
    });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }
}
